var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2083 7.70833V3.33333C25.2083 2.94656 25.0547 2.57563 24.7812 2.30214C24.5077 2.02865 24.1368 1.875 23.75 1.875H4.79167C4.01812 1.875 3.27625 2.18229 2.72927 2.72927C2.18229 3.27625 1.875 4.01812 1.875 4.79167M1.875 4.79167C1.875 5.56521 2.18229 6.30708 2.72927 6.85406C3.27625 7.40104 4.01812 7.70833 4.79167 7.70833H26.6667C27.0534 7.70833 27.4244 7.86198 27.6979 8.13547C27.9714 8.40896 28.125 8.77989 28.125 9.16667V15M1.875 4.79167V25.2083C1.875 25.9819 2.18229 26.7237 2.72927 27.2707C3.27625 27.8177 4.01812 28.125 4.79167 28.125H26.6667C27.0534 28.125 27.4244 27.9714 27.6979 27.6979C27.9714 27.4244 28.125 27.0534 28.125 26.6667V20.8333M28.125 15H23.75C22.9765 15 22.2346 15.3073 21.6876 15.8543C21.1406 16.4013 20.8333 17.1431 20.8333 17.9167C20.8333 18.6902 21.1406 19.4321 21.6876 19.9791C22.2346 20.526 22.9765 20.8333 23.75 20.8333H28.125M28.125 15C28.5118 15 28.8827 15.1536 29.1562 15.4271C29.4297 15.7006 29.5833 16.0716 29.5833 16.4583V19.375C29.5833 19.7618 29.4297 20.1327 29.1562 20.4062C28.8827 20.6797 28.5118 20.8333 28.125 20.8333",
    stroke: "#0071E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/vector-2.016174161dc239e68793bd948f47ef82.svg";
export { ForwardRef as ReactComponent };